import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DeviceManagerService } from 'src/app/core/services/device-manager.service';
import { PurchaseOrderManagerService } from 'src/app/services/purchase-order/purchase-order-manager.service';
import { PurchaseOrderPaymentType } from 'src/app/services/purchase-order/purchase-order.model';
import { SignaturePageType } from '../purchase-order-pdf/purchase-order-pdf.component';
import { AdminEditContact, AdminEditDataBase, AdminEditPaymentType } from 'src/app/services/purchase-order/models/admin-edit-data-base.model';
import * as cloneDeep from 'lodash/cloneDeep';
import { AdminEditSaveModelBase } from 'src/app/services/purchase-order/models/admin-edit-save-base.model';
import { ConfirmationService, MessageService, ScrollerOptions } from 'primeng/api';
import { AdminEditDataWestVirginia } from 'src/app/services/purchase-order/models/admin-edit-data-west-virginia.model';
import { AdminEditSaveModelWestVirginia } from 'src/app/services/purchase-order/models/admin-edit-save-west-virginia.model';
import { ExistingPoVendorListItemModel } from 'src/app/services/purchase-order/models/exising-po-vendor-list-item.model';
import { VendorActivityStatus } from 'src/app/services/vendor/vendor.model';
import { AuthManagerService } from 'src/app/services/auth/auth-manager.service';
import { LocalCacheManager } from 'src/app/managers/local-cache.manager';

export interface PlaceOfSaleOption {
	name: string,
	value: number;
}
@Component({
  selector: 'ls-admin-edit',
  templateUrl: './admin-edit.component.html',
  styleUrl: './admin-edit.component.less'
})
export class AdminEditComponent implements OnInit{
    @Input() pageType: SignaturePageType;
	@Output() complete: EventEmitter<boolean> = new EventEmitter<boolean>();
    selectedPaymentTypes: PurchaseOrderPaymentType[] = []
	selectedContactId: number;
	purchaseOrder: AdminEditDataBase;
	purchaseOrderWV: AdminEditDataWestVirginia;
	totalCash: number;
	totalCheck: number;
	totalWire: number;
	checkNumber: string;

    PageType = SignaturePageType;
	PaymentType = PurchaseOrderPaymentType;
	selectedVendor: ExistingPoVendorListItemModel;
    vendorsFilterValue: string;
    vendors: ExistingPoVendorListItemModel[] = [];
    vendorListLoading: boolean = false;
    pageSize: number = 20;
    pageIndex: number = 0;
    searchString: string = null;
    totalItems: number;
	vendorsScrollerOptions: ScrollerOptions = {
        showLoader: false,
        lazy: true,
        onLazyLoad: this.onLazyLoad.bind(this)
    };

	// placeOfSaleSelected: number = 1;
	placeOfSaleOptions: PlaceOfSaleOption[] = [
		{name: "Seller's Location", value: 1},
		{name: "Buyers's Location", value: 2},
		{name: "Other Location", value: 3},
	]

	userCurrency = LocalCacheManager.currency;
    constructor(
      	public poManager: PurchaseOrderManagerService,
      	public deviceManager: DeviceManagerService,
		private messageService: MessageService,
		private authManager: AuthManagerService,
		private confirmationService: ConfirmationService){}

    ngOnInit(): void {
		if(this.pageType != SignaturePageType.WestVirginia){
			this.poManager.getAdminEditDataBase().subscribe(result => {
				this.purchaseOrder = result;
				this.selectedContactId = this.purchaseOrder.selectedContactId;
				this.selectedVendor = this.purchaseOrder.selectedVendor;
				this.vendors.push(this.selectedVendor)
				this.totalCash = result.paymentTypes.find(x => x.type == PurchaseOrderPaymentType.Cash).total;
				this.totalCheck = result.paymentTypes.find(x => x.type == PurchaseOrderPaymentType.Check).total;
				this.checkNumber = result.paymentTypes.find(x => x.type == PurchaseOrderPaymentType.Check).checkNumber;
				this.totalWire = result.paymentTypes.find(x => x.type == PurchaseOrderPaymentType.WireTransfer)?.total ?? 0;
				this.selectedPaymentTypes = this.purchaseOrder.paymentTypes.filter(x => x.total > 0).map(x => x.type);
			}, () => this.complete.emit(false))
		} else {
			this.poManager.getAdminEditDataWestVirginia().subscribe(result => {
				this.purchaseOrderWV = result;
				this.selectedContactId = this.purchaseOrderWV.selectedContactId;
				this.selectedPaymentTypes = this.purchaseOrderWV.paymentTypes.filter(x => x.total > 0).map(x => x.type);
				this.selectedVendor = this.purchaseOrderWV.selectedVendor;
				this.vendors.push(this.selectedVendor)
			}, () => this.complete.emit(false))
			}
    }
	contactChange(): void {
		if(this.pageType == SignaturePageType.WestVirginia) {
			this.purchaseOrderWV.vehicleMake = this.selectedContact?.vehicleMake;
			this.purchaseOrderWV.vehicleModel = this.selectedContact?.vehicleModel;
			this.purchaseOrderWV.vehicleColor = this.selectedContact?.vehicleColor;
			this.purchaseOrderWV.vehicleNumber = this.selectedContact?.vehicleNumber;
			this.purchaseOrderWV.vehicleState = this.selectedContact?.vehicleState;
			return;
		}
		this.purchaseOrder.vehicleMake = this.selectedContact?.vehicleMake;
		this.purchaseOrder.vehicleModel = this.selectedContact?.vehicleModel;
		this.purchaseOrder.vehicleColor = this.selectedContact?.vehicleColor;
		this.purchaseOrder.vehicleNumber = this.selectedContact?.vehicleNumber;
		this.purchaseOrder.vehicleState = this.selectedContact?.vehicleState;
	}

    isOptional(field: string): boolean {
    	return this.optionals[field].includes(this.pageType)
    }

		onSave(): void{
			let po = this.pageType == SignaturePageType.WestVirginia ? this.purchaseOrderWV : this.purchaseOrder;
			let payments = po.paymentTypes.filter(x => this.selectedPaymentTypes.includes(x.type));

			if(payments.reduce((acc, item) => acc + item.total, 0) != po.total){
				this.messageService.add({
        			severity: 'error',
        			summary: `Admin edit`,
        			detail: 'The entered amount does not match the total required for the selected payment type.'
        		});
				return;
			}

			if(this.pageType == SignaturePageType.WestVirginia){
				this.saveWestVirginiaData(payments);
				return;
			}
			this.saveBaseData(payments);
		}
		private saveWestVirginiaData(payments: AdminEditPaymentType[]): void {
			let saveData: AdminEditSaveModelWestVirginia = {
				vehicleModel: this.purchaseOrderWV.vehicleModel,
				vehicleMake: this.purchaseOrderWV.vehicleMake,
				vehicleColor: this.purchaseOrderWV.vehicleColor,
				vehicleNumber: this.purchaseOrderWV.vehicleNumber,
				vehicleState: this.purchaseOrderWV.vehicleState,
				totalCash: payments.find(x => x.type == PurchaseOrderPaymentType.Cash)?.total,
				totalWire: payments.find(x => x.type == PurchaseOrderPaymentType.WireTransfer)?.total,
				totalCheck: payments.find(x => x.type == PurchaseOrderPaymentType.Check)?.total,
				checkNumber: payments.find(x => x.type == PurchaseOrderPaymentType.Check)?.checkNumber,
				businessAddress: this.purchaseOrderWV.businessAddress,
				homeAddress: this.purchaseOrderWV.homeAddress,
				kindOfScrapMaterials: this.purchaseOrderWV.kindOfScrapMaterials,
				scrapMaterialCollateral: this.purchaseOrderWV.scrapMaterialCollateral,
				scrapMaterialConsignment: this.purchaseOrderWV.scrapMaterialConsignment,
				scrapMaterialPurchased: this.purchaseOrderWV.scrapMaterialPurchased,
				sellerFullName: this.purchaseOrderWV.sellerFullName,
				vendorId: this.selectedVendor.id
			}
			this.poManager.saveAdminEditDataWestVirginia(saveData).subscribe(() => {
				this.complete.emit(true);
			}, () => this.complete.emit(false))
		}
		private saveBaseData(payments: AdminEditPaymentType[]): void {
			if(!this.purchaseOrder.vehicleMake && !this.optionals.make.includes(this.pageType)) {
				this.messageService.add({
        	severity: 'error',
        	summary: `Admin edit`,
        	detail: 'Vehicle make cannot be empty.'
        });
				return
			}
			if(!this.purchaseOrder.vehicleModel && !this.optionals.make.includes(this.pageType)) {
				this.messageService.add({
        	severity: 'error',
        	summary: `Admin edit`,
        	detail: 'Vehicle model cannot be empty.'
        });
				return
			}
			if(!this.purchaseOrder.vehicleColor && !this.optionals.color.includes(this.pageType)) {
				this.messageService.add({
        	severity: 'error',
        	summary: `Admin edit`,
        	detail: 'Vehicle color cannot be empty.'
        });
				return
			}
			if(!this.purchaseOrder.vehicleNumber && !this.optionals.license.includes(this.pageType)) {
				this.messageService.add({
        	severity: 'error',
        	summary: `Admin edit`,
        	detail: 'Vehicle license cannot be empty.'
        });
				return
			}
			if(!this.purchaseOrder.vehicleState && !this.optionals.state.includes(this.pageType)) {
				this.messageService.add({
        	severity: 'error',
        	summary: `Admin edit`,
        	detail: 'Vehicle state cannot be empty.'
        });
				return
			}

			let saveData: AdminEditSaveModelBase = {
				vehicleModel: this.purchaseOrder.vehicleModel,
				vehicleMake: this.purchaseOrder.vehicleMake,
				vehicleColor: this.purchaseOrder.vehicleColor,
				vehicleNumber: this.purchaseOrder.vehicleNumber,
				vehicleState: this.purchaseOrder.vehicleState,
				selectedContactId: this.selectedContactId,
				totalCash: payments.find(x => x.type == PurchaseOrderPaymentType.Cash)?.total,
				totalWire: payments.find(x => x.type == PurchaseOrderPaymentType.WireTransfer)?.total,
				totalCheck: payments.find(x => x.type == PurchaseOrderPaymentType.Check)?.total,
				checkNumber: payments.find(x => x.type == PurchaseOrderPaymentType.Check)?.checkNumber,
				californiaIdNumber: this.purchaseOrder.californiaIdNumber,
				middleInitial: this.purchaseOrder.middleInitial,
				placeOfSale: this.purchaseOrder.placeOfSale,
				vendorId: this.selectedVendor.id,
			}
			if(this.purchaseOrder.placeOfSale == 3){
				saveData.placeOfSaleLocationAddress = this.purchaseOrder.placeOfSaleLocationAddress;
				saveData.placeOfSaleLocationCity = this.purchaseOrder.placeOfSaleLocationCity;
				saveData.placeOfSaleLocationState = this.purchaseOrder.placeOfSaleLocationState;
				saveData.placeOfSaleLocationZip = this.purchaseOrder.placeOfSaleLocationZip;
			}
			this.poManager.saveAdminEditDataBase(saveData).subscribe(() => {
				this.complete.emit(true);	
			}, () => this.complete.emit(false))
		}
		get selectedContact(): AdminEditContact | null {
			return this.pageType == SignaturePageType.WestVirginia ? this.purchaseOrderWV?.contacts?.find(x => x.id == this.selectedContactId) : this.purchaseOrder?.contacts?.find(x => x.id == this.selectedContactId);
		}
		onCancel(): void {
			this.complete.emit(false);
		}
    optionals = {
			make: [SignaturePageType.California, SignaturePageType.Illinois, SignaturePageType.Default],
      model: [SignaturePageType.California, SignaturePageType.Illinois, SignaturePageType.Default],
      color: [SignaturePageType.California, SignaturePageType.Illinois, SignaturePageType.Default],
      license: [SignaturePageType.Illinois, SignaturePageType.Default],
      state: [SignaturePageType.Illinois, SignaturePageType.Default]
    }

	    onFilterVendors(e: any){
        this.searchString = this.vendorsFilterValue;
        this.loadVendorsPage(0);
    }
    onClearVendorsFilter(): void {
        this.searchString = undefined;
        this.vendorsFilterValue = undefined
        this.loadVendorsPage(0);
    }
    onLazyLoad(event) {
        if (this.vendors.length >= this.totalItems)
            return;

        const { _, last } = event;
        if (last >= this.vendors.length && !this.vendorListLoading) {
            this.vendorListLoading = true;

            let nextPage = Math.floor(this.vendors.length / this.pageSize);
            this.loadVendorsPage(nextPage)
        }
    }
    loadVendorsPage(page: number): void
    {
        this.poManager.getVendorsForExistingPo(this.authManager.currentUser.locationId, this.authManager.currentUser.isVendorAdmin, {
            pageIndex: page,
            pageSize: this.pageSize,
            searchString: this.searchString
        }).subscribe((vendors) => {
            this.totalItems = vendors.totalCount;
            let items = vendors.items.filter(v => v.id === this.poManager.current.vendorId ||
                     (v.activityStatus !== VendorActivityStatus.Inactive && v.activityStatus !== VendorActivityStatus.NotSelling));

            if(page == 0) 
                this.vendors = items;
            else
                this.vendors = [...this.vendors, ...items];
            this.vendorListLoading = false;
            setTimeout(() => this.selectedVendor = this.vendors.find(x => x.id == this.poManager.current.vendor.id), 100);
        });
    }
    get vendorsLoaded(): boolean {
        if (this.vendors.length == 0 || (this.vendors.length == 1 && this.vendors[0].id == this.poManager.current.vendorId)){
            return false;
        }
        return true;
    }

	vendorhasCompleteData: boolean = true;
	changeVendor(event: any): void
    {
        if (this.selectedVendor.id === this.poManager.current.vendor.id) 
        {
			this.selectedContactId = this.purchaseOrder.selectedContactId
			return;
		}

		this.selectedContactId = undefined;
			


        const userExempt = this.authManager.currentUser.exemptFromVendorLicenseRequirements;
        if ((userExempt && !event.value.hasCompleteData && event.value.hasCompleteLicenseData) || (!userExempt && !event.value.hasCompleteData))
        {
            this.vendorhasCompleteData = false;
			return;
        }
		this.vendorhasCompleteData = true;
    }
}
